import { render, staticRenderFns } from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=template&id=89bf85f4&scoped=true"
import script from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=script&lang=js"
export * from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=script&lang=js"
import style0 from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=style&index=0&id=89bf85f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bf85f4",
  null
  
)

export default component.exports